"use client"

import { useEffect } from "react"
import { isCapacitorNative } from "@/lib/capacitor"

/**
 * Service workers are unreliable in iOS WKWebView and can cause blank/black
 * screens after cold start when navigation is intercepted or cache is stale.
 * Only register the PWA SW on real browsers; unregister on Capacitor.
 */
export function ServiceWorkerRegistration() {
  useEffect(() => {
    if (typeof navigator === "undefined" || !("serviceWorker" in navigator)) return

    if (isCapacitorNative()) {
      void navigator.serviceWorker.getRegistrations().then((regs) => {
        regs.forEach((r) => void r.unregister())
      })
      return
    }

    // Vite dev: SW fights HMR; avoid intercepting /api and navigations.
    if (import.meta.env.DEV) {
      void navigator.serviceWorker.getRegistrations().then((regs) => {
        regs.forEach((r) => void r.unregister())
      })
      return
    }

    void navigator.serviceWorker.register("/sw.js", { scope: "/" }).catch(() => {})
  }, [])

  return null
}
